<template>
  <v-card>
    <ac-data-table
      :headers="headers"
      :items="headerFilter(items)"
      :item-class="row_class"
      hide-default-footer
      disable-pagination
      sort-by="item.string"
      item-key="uid"
      fixed-header
      :height="winsize.height - 145"

      :search.sync="search"
      v-model="selected"

      :can-select="item => !row_readonly(item)"
      :can-delete="item => !row_readonly(item)"
      :remove-bulk="bulkRemove"
      :bulk-mode.sync="bulkMode"

      title="Currencies"
    >
      <template #actions>
        <v-btn @click="row_create" class="ma-2" color="primary">
          New Currency
        </v-btn>
      </template>

      <template #bulk-extra>
        <v-btn
          x-small
          class="ma-2 white--text"
          color="blue"
          :disabled="!bulkMode || selected.length === 0"
          @click="bulkCopy"
        >
          Bulk Copy
          <span v-if="selected.length"> ({{ selected.length }})</span>
        </v-btn>
      </template>

      <template v-for="(header,index) in headers" v-slot:[`header.${header.value}`]>
        <span v-if="header.filters" :key="index">
          {{ header.text }}
           <v-menu offset-y :close-on-content-click="false">
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on">
                  <v-icon small :color="header.filters.length ? 'primary' : ''">
                    mdi-filter-variant
                  </v-icon>
                </v-btn>
              </template>
              <div style="background-color: white; width: 280px">
                <v-list>
                  <v-list-item>
                      <v-autocomplete
                          v-model="header.filters"
                          :items="headerFilterValues(header)"
                          label="Select filters"
                          class="mt-3"
                          chips small-chips
                          auto-select-first
                          multiple dense
                          color="light-blue lighten-3"
                          append-icon="mdi-filter">
                            <template v-slot:selection="data">
                              <v-chip
                                  v-bind="data.attrs"
                                  :input-value="data.selected"
                                  close small class="ma-1"
                                  @click="data.select"
                                  @click:close="headerFilterRemove(header,data.item)"
                              >
                                {{ data.item }}
                              </v-chip>
                            </template>
                            <template v-slot:item="data">
                                <v-list-item-content v-text="data.item"/>
                            </template>
                      </v-autocomplete>
                  </v-list-item>
                </v-list>
              </div>
            </v-menu>
        </span>
        <span v-else :key="index+1">
          {{ header.text }}
        </span>
      </template>
      <template v-slot:item.icon="{item}">
        <v-image-view style="width: 50px;height: 50px" :path="getImage(item)"/>
      </template>
      <template v-slot:item.enabled="{item}">
        <v-label>{{ item.enabled ? "ON" : "OFF" }}</v-label>
      </template>
      <template v-slot:item.actions="{item}">
        <v-icon v-if="row_readonly(item)" @click="row_view(item)" class="mr-2" small color="green">
          mdi-eye
        </v-icon>
        <v-icon v-else-if="item.locked" @click="row_update(item)" class="mr-2" small color="orange">
          mdi-pencil
        </v-icon>
        <v-icon v-else @click="row_update(item)" class="mr-2" small color="green">
          mdi-pencil
        </v-icon>
        <v-icon @click="row_copy(item)" class="mr-2" small color="teal lighten-1">
          mdi-content-copy
        </v-icon>
        <v-icon :disabled="item.global || item.shared" @click="row_export(item)" class="mr-2" small color="blue">mdi-briefcase-upload</v-icon>
        <v-icon :disabled="row_readonly(item)" @click="row_remove(item)" class="mr-2" small color="red">
          mdi-delete
        </v-icon>
        <v-icon :disabled="item.global || item.shared" @click="row_convert(item)" class="mr-2" small color="blue">mdi-cloud-upload-outline</v-icon>
      </template>
      <template v-slot:no-results>
        <v-alert :value="true" color="blue-grey" dense>
          Your search for "{{ search }}" found no results.
        </v-alert>
      </template>

    </ac-data-table>
    <r-currency-config-dialog ref="dialog"/>
    <r-bulk-copy-dialog ref="bulkCopyDialog"/>

    <v-overlay :value="bulkCopyLoading" z-index="999">
      <v-progress-circular indeterminate size="64"/>
    </v-overlay>
  </v-card>
</template>

<script>
import VueTypes from "vue-types";
import {ViewRules} from "@/common/ViewRules";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";
import {CurrencyConfig} from "@/modules/redactor/models/currency/CurrencyConfig";
import {getObjectValueByPath} from "vuetify/lib/util/helpers";
import {serialize, deserialize} from "serializr";
import {uuid} from "vue-uuid";

import VImageView from "@/views/com/ImageView";
import RCurrencyConfigDialog from "@/modules/redactor/views/currency/r-currency-config-dialog";
import AcDataTable from "@/components/Table/ac-data-table.vue";
import RBulkCopyDialog from "@/components/Dialog/r-bulk-copy-dialog.vue";


export default {
  name: "r-currency-page",
  components: {AcDataTable, RCurrencyConfigDialog, VImageView, RBulkCopyDialog},
  data: () => ({
    search: "",
    headers: [
      {text: "Kind", value: "kind.key"},
      {text: "Icon", value: "icon", sortable: false},
      {text: "Group", value: "group.key", filters: []},
      {text: "Level", value: "guard.level.string"},
      {text: "Order", value: "order"},
      {text: "Formulas", value: "formulas.length"},
      {text: "Enabled", value: "enabled"},
      {text: "UID", value: "uid"},
      {text: '', value: 'actions', width: '100%', sortable: false, align: 'end'}
    ],
    items: {
      type: VueTypes.arrayOf(CurrencyConfig)
    },
    selected: [],
    bulkMode: false,
    bulkCopyLoading: false,
  }),
  computed: {
    masterAccess() {
      return RedactorUtils.hasMasterAccess();
    },
    winsize() {
      return window.app.winsize;
    }
  },
  methods: {
    row_view(item) {
      this.$refs['dialog'].show(ViewRules.READONLY, item.clone()).catch(() => {
      });
    },
    row_copy(item) {
      this.$refs['dialog'].show(ViewRules.COPY, item.copy()).then(
          result => {
            RedactorUtils.pushCurrencyConfig(result).then(
                () => {
                  this.$alert("Changes was published");
                });
          }, () => {
          });
    },
    row_create() {
      this.$refs['dialog'].show(ViewRules.CREATE, null).then(
          result => {
            RedactorUtils.pushCurrencyConfig(result).then(
                () => {
                  this.$alert("Changes was published");
                });
          }, () => {
          });
    },
    row_update(item) {
      this.$refs['dialog'].show(ViewRules.UPDATE, item.clone()).then(
          result => {
            RedactorUtils.pushCurrencyConfig(result).then(
                () => {
                  this.$alert("Changes was published");
                });
          }, () => {
          });
    },
    row_remove(item) {
      this.$confirm("Are you sure you want to delete this item?").then(() => {
        RedactorUtils.removeCurrencyConfig(item).then(
            () => {
              this.$alert("Changes was published");
            });
      });
    },

    bulkRemove(items) {
      return RedactorUtils.removeBulkCurrencyConfigs(items);
    },

    async bulkCopy() {
      if (!this.selected || this.selected.length === 0) {
        this.$alert("No items selected");
        return;
      }

      try {
        const { search, replace } = await this.$refs['bulkCopyDialog'].show(this.selected.length);

        this.bulkCopyLoading = true;

        const copiedItems = [];
        const errors = [];
        let successCount = 0;
        let autoCreatedKind = null;
        const createdKinds = new Set();
        const skippedKinds = new Set();

        const searchRegex = new RegExp(search.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'gi');

        for (const item of this.selected) {
          try {
            const originalJson = serialize(CurrencyConfig, item);
            let jsonString = JSON.stringify(originalJson);

            // Check if currency kind will change and handle accordingly
            const oldKindKey = item?.kind?.key;
            if (oldKindKey && searchRegex.test(oldKindKey)) {
              searchRegex.lastIndex = 0;
              const newKindKey = oldKindKey.replace(searchRegex, replace);
              searchRegex.lastIndex = 0;

              let newKind = RedactorUtils.getCurrencyKindByKey(newKindKey);
              if (!newKind && !createdKinds.has(newKindKey)) {
                if (skippedKinds.has(newKindKey)) {
                  continue;
                }

                try {
                  await this.$confirm(`Currency kind "${newKindKey}" does not exist. Create it automatically?`);
                } catch {
                  skippedKinds.add(newKindKey);
                  continue;
                }

                const originalKind = RedactorUtils.getCurrencyKindByKey(oldKindKey);
                if (originalKind) {
                  newKind = originalKind.copy();
                  newKind._key = newKindKey;
                  newKind._enabled = true;

                  const allKinds = RedactorUtils.getCurrencyKinds();
                  const maxCode = Math.max(...allKinds.map(k => k.code || 0));
                  newKind._code = maxCode + 1;

                  try {
                    await RedactorUtils.pushCurrencyKind(newKind);
                    createdKinds.add(newKindKey);
                    autoCreatedKind = newKindKey;
                  } catch (kindError) {
                    errors.push(`Failed to create kind "${newKindKey}": ${kindError.message}`);
                    continue;
                  }
                } else {
                  errors.push(`Cannot create kind "${newKindKey}": original kind "${oldKindKey}" not found.`);
                  continue;
                }
              } else if (skippedKinds.has(newKindKey)) {
                continue;
              }
            }
            searchRegex.lastIndex = 0;

            jsonString = jsonString.replace(searchRegex, replace);
            searchRegex.lastIndex = 0;
            const modifiedJson = JSON.parse(jsonString);

            modifiedJson.uid = uuid.v4().replace(/-/g, "");
            modifiedJson.export = false;
            modifiedJson.global = false;

            const copiedItem = deserialize(CurrencyConfig, modifiedJson);

            if (!copiedItem) {
              errors.push(`Deserialization failed for ${item?.kind?.key || 'currency'}.`);
              continue;
            }

            copiedItems.push(copiedItem);
            successCount++;
          } catch (error) {
            const itemName = item?.kind?.key || 'unknown currency';
            errors.push(`Error copying ${itemName}: ${error.message}`);
          }
        }

        if (copiedItems.length > 0) {
          for (const copiedItem of copiedItems) {
            try {
              await RedactorUtils.pushCurrencyConfig(copiedItem);
            } catch (pushError) {
              errors.push(`Error pushing ${copiedItem?.kind?.key || 'unknown'}: ${pushError.message}`);
            }
          }
        }

        let message = `Successfully copied ${successCount} currency(ies)`;
        if (autoCreatedKind) {
          message += `\n\nAuto-created new currency kind: "${autoCreatedKind}"`;
        }
        if (errors.length > 0) {
          message += `\n\nErrors:\n${errors.join('\n')}`;
        }

        this.$alert(message, "Bulk Copy", errors.length > 0 ? "warning" : "success");

        this.selected = [];
        this.bulkMode = false;

      } catch (error) {
        if (error.message !== "Cancelled") {
          this.$alert(error.message, "Bulk Copy Error", "error");
        }
      } finally {
        this.bulkCopyLoading = false;
      }
    },

    row_export(item) {
      let result = item.clone();
      result.export = !item.export;
      RedactorUtils.pushCurrencyConfig(result);
    },
    row_convert(item) {
      this.$confirm("Are you sure you want to move this item to global config?")
          .then(() => {
            RedactorUtils.convertCurrencyConfig(item.clone())
                .then(() => {
                  this.$alert("Changes was published", "Convert To Global", "success");
                })
                .catch((error) => {
                  this.$alert(error, "Convert To Global", "error");
                });
          });
    },

    row_class(item) {
      if (item.shared) {
        return "yellow lighten-4"
      } else if (item.global) {
        return "cyan lighten-4"
      } else if (item.export) {
        return "green lighten-3"
      } else if (item.changed) {
        return "blue lighten-3"
      } else if (!item.enabled) {
        return "blue-grey lighten-3"
      }
    },
    row_readonly(item) {
      return (item.locked && !this.masterAccess) || item.global || item.shared;
    },

    getImage(item) {
      if (item && item.kind) {
        return 'assets/currency/' + item.kind.key + '.png'
      } else {
        return "";
      }
    },

    headerFilter(items) {
      let hh = this.headers.filter(h => {
        return h.filters && h.filters.length > 0
      });

      if (hh.length === 0) {
        return items;
      } else {
        return items.filter(item => {
          return hh.every(header => {
            let value = getObjectValueByPath(item, header.value);
            if (!value) {
              return false;
            }

            let text = value.toString().toLocaleLowerCase();
            return header.filters.some(v => {
              return text.includes(v.toString().toLocaleLowerCase());
            });
          });
        });
      }
    },
    headerFilterValues(header) {
      let values = this.items.map(item => {
        return getObjectValueByPath(item, header.value);
      });

      let unique = [...new Set(values.filter(v => v))];
      return unique;
    },
    headerFilterRemove(header, filter) {
      const index = header.filters.indexOf(filter)
      if (index >= 0) header.filters.splice(index, 1)
    }
  },
  created() {
    this.items = RedactorUtils.getCurrencyConfigs();
  }
}
</script>